<template>
  <div class="jobs-page-holder">
    <div class="jobs">
      <div class="main-content-wrapper">
        <div class="page-header d-flex flex-row">
          <h1 class="m-0 flex-fill font-weight-bold">Jobs MEILI</h1>
        </div>
      </div>
      <div class="main-content-wrapper">
        <JobsFilter :result-count="resultCount" />
      </div>
      <div class="main-content-wrapper table-holder">
        <JobsMeiliTable :jobs="jobs" :is-loading="isLoading" />
      </div>
      <TablePagination ref="tablePagination" :meta="paginationMeta" :total-rows="totalRows" />
      <TablePaginationInfo :meta="paginationMeta" description="jobs" />
    </div>
    <JobBatchEditFooter v-if="$store.state.selectedOrderItems.length > 0" />
    <JobsLocationSelectorModal @submitted="getJobsWithQuery" />
    <JobsStatusSelectorModal />
    <JobsRefundRequestModal />
    <CreateShippingOrderModal :key="$store.getters.createShippingOrderModalKey" />
    <!-- DP-4478 -->
    <ManageShippingModal />
    <CaShipmentModal />
    <CommentsModal />
    <ActivityHistoryModal />
    <ContactLensPrescriptionModal />
    <OrderLensModal />
    <PrintModal />
    <JobEditModal v-if="showJobEditModal" />
    <FileModal />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import apiOrders from '@/api/orders';
import JobsMeiliTable from '@/components/JobsMeiliTable.vue';
import TablePagination from '@/components/TablePagination.vue';
import JobsFilter from '@/components/JobsFilter.vue';
import JobBatchEditFooter from '@/components/JobBatchEditFooter.vue';
import JobsLocationSelectorModal from '@/components/JobsLocationSelectorModal.vue';
import JobsStatusSelectorModal from '@/components/JobsStatusSelectorModal.vue';
import JobsRefundRequestModal from '@/components/JobsRefundRequestModal.vue';
import CommentsModal from '@/components/CommentsModal.vue';
import ActivityHistoryModal from '@/components/ActivityHistoryModal.vue';
import ContactLensPrescriptionModal from '@/components/ContactLensPrescriptionModal.vue';
import OrderLensModal from '@/components/OrderLensModal.vue';
import PrintModal from '@/components/modals/PrintModal.vue';
import FileModal from '@/components/modals/FileModal.vue';
import CreateShippingOrderModal from '@/views/modals/CreateShippingOrder/index.vue';
import ManageShippingModal from '@/views/modals/ManageShipping/index.vue';
import CaShipmentModal from '@/views/modals/ManageShipping/CaShipmentModal.vue';
import TablePaginationInfo from '@/components/TablePaginationInfo.vue';
import JobEditModal from '@/components/job-edit-modal/JobEditModal.vue';

export default {
  name: 'Jobs',
  components: {
    OrderLensModal,
    TablePaginationInfo,
    CommentsModal,
    ActivityHistoryModal,
    ContactLensPrescriptionModal,
    CreateShippingOrderModal,
    ManageShippingModal,
    CaShipmentModal,
    JobsStatusSelectorModal,
    JobsLocationSelectorModal,
    JobsRefundRequestModal,
    JobBatchEditFooter,
    JobsFilter,
    TablePagination,
    JobsMeiliTable,
    PrintModal,
    FileModal,
    JobEditModal,
  },
  data() {
    return {
      isLoading: false,
      totalRows: 0,
      resultCount: null,
      paginationMeta: {},
    };
  },
  computed: {
    ...mapState({
      jobs: state => state.jobs,
      showJobEditModal: state => state.jobsModule.showJobEditModal,
    }),
    ...mapGetters(['selectedOrder']),
  },
  beforeMount() {
    this.$store.dispatch('setLensSuppliers');
  },
  created() {
    this.getJobsWithQuery();
    this.$store.commit('jobsModule/GET_ALL_COLORS');
    this.$root.$on('commentsRefreshed', () => {
      //  this.getJobsWithQuery();
    });
  },
  methods: {
    getJobs(params = {}) {
      this.isLoading = true;
      apiOrders
        .getMeiliOrders({
          ...params,
          order_item_append: 'next_scheduled_date',
          product_type_append: 'lenses_type',
          action: 'list',
        })
        .then(({ data }) => {
          this.paginationMeta = data;
          this.totalRows = data.total;
          this.resultCount = data.total;
          this.$store.commit('SET_JOBS_MEILI', data.data.hits);
        })
        .finally(() => {
          this.isLoading = false;
          if (this.$refs.tablePagination) {
            this.$refs.tablePagination.refreshPage();
          }
        });
    },
    getJobsWithQuery() {
      const { query } = this.$route;

      if (!query.sort_by) {
        query.sort_by = 'created_at';
        query.sort_direction = 'desc';
      }
      this.getJobs(query);
    },
  },
  watch: {
    $route() {
      this.getJobsWithQuery();
    },
  },
};
</script>
